import { settingsSelectors, State, TabDisplayInterface } from '@wam/shared';
import { Injectable, inject } from '@angular/core';
import { combineLatest, Observable, of } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { isStaff } from '@app/authentication/user.data';
import { RosteringService } from '@app/teacher-users/rostering-data.service';

@Injectable({
  providedIn: 'root',
})
export class GoalsTabDisplayService implements TabDisplayInterface {
  private store = inject<Store<State>>(Store);
  private readonly rosteringService = inject<RosteringService>(RosteringService);

  isFirst(): Observable<boolean> {
    return of(false);
  }

  shouldShow(): Observable<boolean> {
    return combineLatest([
      this.store.pipe(select(settingsSelectors.getUserType)),
      this.rosteringService.applyEIRRestrictions(),
    ]).pipe(map(([userType, applyRestrictions]) => !applyRestrictions && isStaff(userType)));
  }
}
